// Almacena el accessToken en memoria (fuente de verdad) con sessionStorage
// como respaldo para sobrevivir un refresh de página en dev. Nunca localStorage.
const STORAGE_KEY = 'ls_access_token';

let memoryToken: string | null = null;

export function getToken(): string | null {
  if (memoryToken) return memoryToken;

  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (stored) memoryToken = stored;

  return memoryToken;
}

export function setToken(token: string): void {
  memoryToken = token;
  sessionStorage.setItem(STORAGE_KEY, token);
}

export function clearToken(): void {
  memoryToken = null;
  sessionStorage.removeItem(STORAGE_KEY);
}
